import styled from 'styled-components';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import pageSpacingConfig from './config';

const StyledSpacingWrapper = styled.div.attrs({
	className: 'fuse-spacing-wrapper',
})`
	margin-bottom: ${({ marginBottom }) =>
		marginBottom ? pageSpacingConfig[marginBottom].xxs : pageSpacingConfig.l.xxs};

	@media screen and (min-width: ${gridConfig.m.minWidth}) {
		margin-bottom: ${({ marginBottom }) =>
		marginBottom ? pageSpacingConfig[marginBottom].m : pageSpacingConfig.l.m};
	}

	@media screen and (min-width: ${gridConfig.l.minWidth}) {
		margin-bottom: ${({ marginBottom }) =>
		marginBottom ? pageSpacingConfig[marginBottom].l : pageSpacingConfig.l.l};
	}
`;

export default StyledSpacingWrapper;
